import { RouteConfig } from 'vue-router'

const route: RouteConfig[] = [
  {
    path: '/calendar',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/Calendar/Index.vue'),
        children: [
          {
            path: ':eventId',
            component: () => import('pages/Calendar/Detail.vue'),
            meta: { requiresEditor: true }
          },
          {
            path: 'new',
            component: () => import('pages/Calendar/Detail.vue'),
            meta: { requiresEditor: true }
          }
        ]
      }
    ],
    meta: { requiresAuth: true }
  }
]

export default route
